<template>
<div class="chapter">
<div class="inner_page">
<div id="cov"><img alt="image" src="images/9780312331924.jpg" style="height:100%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?0aff24eb